import { useCallback, useEffect, useState } from "react";
import { useApi } from "../../../hooks/useApi";

/**
 * Latest published announcement for this org. Fetched once on mount
 * (refresh to pick up a new post). Dismiss is org-wide for that id only.
 */
export function useActiveAnnouncement() {
  const api = useApi();
  const [announcement, setAnnouncement] = useState(null);
  const [canDismiss, setCanDismiss] = useState(false);
  const [closing, setClosing] = useState(false);

  useEffect(() => {
    let dead = false;
    api.get("/api/v1/announcements/active")
      .then((r) => {
        if (dead) return;
        setAnnouncement(r.data?.data?.announcement || null);
        setCanDismiss(r.data?.data?.canDismiss === true);
      })
      .catch(() => { /* stay hidden if the read fails */ });
    return () => { dead = true; };
  }, [api]);

  const dismiss = useCallback(async () => {
    if (!announcement?.id || !canDismiss) return;
    setClosing(true);
    try {
      await api.post(`/api/v1/announcements/${announcement.id}/dismiss`);
      setAnnouncement(null);
    } catch (_e) {
      setClosing(false);
    }
  }, [api, announcement, canDismiss]);

  return { announcement, canDismiss, closing, dismiss };
}

export default useActiveAnnouncement;
